import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class DeliveryOptionsService {
  fetchDeliveryOptions = () => {
    return fetch(config.config.endpointUrls.fetchDeliveryOptions(), {
      method: 'GET'
    })
  }
}

export default new DeliveryOptionsService()



// WEBPACK FOOTER //
// ../src/services/deliveryOptionsService/deliveryOptionsService.js